import { motion, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { RevealOnView } from "@/components/Reveal";
import { AXIOM } from "@/constants/testIds";

const STATS = [
  { value: 30, suffix: "+", label: "Years manufacturing experience" },
  { value: 15, suffix: "+", label: "Years simulation experience" },
  { value: 3, suffix: "L+", label: "Units shipped by founding team" },
  { value: 10, suffix: "+", label: "Domain & manufacturing partners" },
];

function Counter({ target, suffix, duration = 1400 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let start;
    let raf;
    const tick = (t) => {
      if (!start) start = t;
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target, duration]);
  return (
    <span ref={ref} className="tabular-nums">
      {n}
      <span className="text-forge">{suffix}</span>
    </span>
  );
}

export default function Stats() {
  return (
    <section data-testid={AXIOM.stats} className="bg-bg py-20 md:py-24 border-t border-rule">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4">
          {STATS.map((s, i) => (
            <RevealOnView key={s.label} delay={i * 0.06}>
              <div className={`p-10 md:p-12 text-center border-b md:border-b-0 border-rule ${i < STATS.length - 1 ? "md:border-r md:border-rule" : ""}`}>
                <div
                  className="font-display text-ink"
                  style={{ fontSize: "clamp(32px, 4vw, 48px)", lineHeight: 1, letterSpacing: "-0.02em" }}
                >
                  <Counter target={s.value} suffix={s.suffix} />
                </div>
                <div className="mt-4 font-mono text-[11px] tracking-[0.14em] uppercase text-smoke">
                  {s.label}
                </div>
              </div>
            </RevealOnView>
          ))}
        </div>
      </div>
    </section>
  );
}
